<!-- MP-5754: a CLIENT gets no invite / pending-candidates buttons; userObject.firm is absent for that role. -->
<app-heading [title]="'Worked Together'" [showToggle]="false" [button]="!clientMode() && headingButton" [extraButton]="!clientMode() && !userObject.firm.reviewerAutoApproval && pendingCandidateButton"></app-heading>
<div class="projects-data">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0">
            <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 xl:col-6 lg:col-6 sm:col-12 p-0">
                    <div class="wrap-left">
                       <div class="grid grid-nogutter">
                            <div class="md:pr-1 sm:pr-0 col-12 md:col-4 sm:col-12 ">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon (click)="onSearchClick()"  styleClass="pi pi-search" />
                                    <input [(ngModel)]="searchText" (keydown)="onEnter($event)" type="text" pInputText placeholder="Search" />
                                </p-iconField>
                            </div>
                            @if(!clientMode()){
                            <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                                <p-dropdown  [(ngModel)]="selectedSortOrder"  (onChange)="onSortChange($event)" [options]="sortings" optionLabel="name"
                                [placeholder]="'Sort By' | sentenceCase" />

                                
                            </div>
                            <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                                <p-dropdown [(ngModel)]="selectedUserFilter"  (onChange)="onFilterChange($event)" [options]="userFilters" optionLabel="name"
                                [placeholder]="'User Filter' | sentenceCase" />
                            </div>    
                            }
                            <div class="p-0 col-12 md:col-12 sm:col-12">
                                <ul class="chips">
                                    @if(displaySearchTextChip){
                                        <li><p-chip [label]="searchTextDisplaying" (onRemove)="onRemoveChip('searchText')" [removable]="true" /></li>
                                    }
                                    @if(selectedSortOrder && selectedSortOrder.name){
                                        <li><p-chip [label]="selectedSortOrder.name" (onRemove)="onRemoveChip('sortOrder')" [removable]="true" /></li>
                                    }
                                    @if(!clientMode() && selectedUserFilter && selectedUserFilter.name){
                                        <li><p-chip [label]="selectedUserFilter.name"/></li>
                                    }
                                    </ul>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <div class="data-table">
                @if(clientMode()){
                <!-- MP-5754: read-only; name opens the redacted profile card, no remove action, no email. -->
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal" id="client-portal-worked-together"
                [value]="filteredPortalReviewers()"
                [rows]="10"
                [paginator]="true"
                [showCurrentPageReport]="true"
                [tableStyle]="{ 'min-width': '50rem' }"
                    currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
                    autoLayout="true"
                    [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:30%">Name</th>
                            <th style="width:20%">Rating</th>
                            @if(isPwcEnabled){
                                <th style="width:15%">Ranking</th>
                            }
                            <th style="width:20%">{{'Projects Together' | sentenceCase}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-reviewer>
                        <tr>
                            <td>
                                <span class="cursor-pointer reviewer-name" (click)="openReviewerDialog(reviewer._id)">
                                    {{reviewer.firstName}} {{reviewer.lastName}}
                                </span>
                                @if(reviewer.isCurrentlyWorking){
                                    <p-tag class="ml-2 currently-working" severity="success" [value]="'Currently working' | sentenceCase"></p-tag>
                                }
                            </td>
                            <td>
                                <p-rating [ngModel]="reviewer.starRating" [readonly]="true" [cancel]="false" class="cursor-default"/>
                            </td>
                            @if(isPwcEnabled){
                                <td>{{reviewer.ranking || '-'}}</td>
                            }
                            <td>
                                <span [pTooltip]="portalProjectNames(reviewer)" tooltipPosition="top">{{reviewer.projectsTogether}}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr><td colspan="4">No reviewers have worked on your group's projects yet.</td></tr>
                    </ng-template>
                </p-table>
                } @else {
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal"
                [value]="reviewers" 
                [lazy]="true"
                [rows]="10"
                [paginator]="true"
                [totalRecords]="reviewerCount"
                (onLazyLoad)="getReviewers($event)"
                [showCurrentPageReport]="true" 
                [paginator]="true" 
                [tableStyle]="{ 'min-width': '50rem' }"
                    currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
                    autoLayout="true"
                    [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:20%">
                                Name
                            </th>
                            <th style="width:20%">
                                Email
                            </th>
                            <th style="width:20%">
                                Rating
                            </th>
                            <th style="width:20%">
                              {{'Projects Together' | sentenceCase}}
                            </th>
                            @if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                                } @else {
                                <th>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            }
                            <ng-template #frozenHeader>
                            Actions
                            </ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-reviewer>
                        <tr>
                            <td><span class="cursor-pointer" (click)="openReviewerDialog(reviewer._id)">
                                {{reviewer.firstName}} {{reviewer.lastName}}
                            </span></td>
                            <td  class="cursor-pointer" (click)="openReviewerDialog(reviewer._id)">{{reviewer.email}}</td>
                            <td>
                                <p-rating [(ngModel)]="reviewer.defaultTenantRating" [readonly]="true" [cancel]="false" class="cursor-default"/>
                            </td>
                            <td>{{reviewer.projectsTogether}}</td>
                                @if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                                } @else {
                                <td>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                                } 
                                <ng-template #frozenData>
                                    <div class="wrap-actions">
                                        <p-button [pTooltip]="'Remove from Worked Together List' | sentenceCase" tooltipPosition="top"  (click)="removeFromWorkTogetherList($event,reviewer)"   [rounded]="true" [text]="true" icon="true">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                                        </p-button>
                                    </div>
                                </ng-template>
                        </tr>
                    </ng-template>
                </p-table>
                }
            </div>
        </div>
    </div>
</div>


